import '@/angular/angular-slick-carousel/angular-slick.js';

import 'angular-smart-table';
import 'angularjs-datepicker';

import AngularSanizite from 'angular-sanitize/index.js';
import ClpDashboardComponents from './angular/clp-dashboard.components.js';
import ConferencesComponents from './angular/conferences.components.js';
import AdminComponents from './angular/admin-portal.components.js';

// CLP Angular Module
angular.module('clpDashboard', [
    'slickCarousel',
    AngularSanizite,
    ClpDashboardComponents
]);

// Conferences Module
angular.module('conferenceDetails', [
    ConferencesComponents
]);

// Admin Modul
angular.module('adminPortal', [
    '720kb.datepicker',
    'smart-table',
    AdminComponents
]);

if($('#clpDashboard').length > 0) {
    angular.bootstrap(document.getElementById('clpDashboard'), ['clpDashboard']);
}

if($('#conferenceDetails').length > 0) {
    angular.bootstrap(document.getElementById('conferenceDetails'), ['conferenceDetails']);
}

if($('#adminPortal').length > 0) {
    angular.bootstrap(document.getElementById('adminPortal'), ['adminPortal']);
}

require('./components/collapse-toggle/collapse-toggle.js');
require('./components/overlay/overlay.authoring.js');
require('./components/overlay/overlay.js');
require('./components/grid-gallery/grid-gallery.js');
require('./components/clp-resources-hero/clp.resources.hero.js');
require('./components/reports-access/reports-access.js');
require('./components/download-redirect/download-redirect.js');
require('./components/privacy-policy/privacy-policy.js');
require('./components/checkout/checkout.js');
require('./components/char-limit/char-limit.js');
require('./components/admin-email/admin-email.js');
require('./components/conference-redirect/conference-redirect.js');



// WEBPACK FOOTER //
// ./src/app/index.js